export default __webpack_public_path__ + "static/media/katilim.aec2f7a5.svg";